import React from 'react'

import flip from '../../images/FLIP.jpg'
import flip2 from '../../images/FLIP 2.jpg'
import flip3 from '../../images/FLIP 3.jpg'
import flip4 from '../../images/FLIP 4.jpg'
import flip5 from '../../images/FLIP 5.jpg'

function Flip() {
  return (
    <div className="Project-page container">
      <div className="row">
        <div className="col-md-6">
          <img
            src={flip5}
            className="project-image" />
          <img
            src={flip2}
            className="project-image" />
          <img
            src={flip3}
            className="project-image" />
          <img
            src={flip}
            className="project-image" />
        </div>
        <div className="Project-content col-md-6">
          <h1>Flip</h1>
          <p className="Project-text">
            <strong>
              Short Film
<br />
New Zealand Film Commission
<br />

Director: Jessica Grace Smith
<br />
2018
<br />
              <br />

Casting + Rehearsal + On Set Acting Coach
<br />
Coached supporting lead actor (age 13)
            </strong>
          </p>
          <p className="Project-testimonial">
            "Ella was the child acting coach on my films which have screened and won awards at academy award accredited festivals worldwide, and I am in no doubt that is because of the brilliant performances on screen by the young people in them. She instills confidence in each person and draws a performance so truthful, gaining trust easily by participating in exercises herself, alongside the actors. I can’t wait to work with her again.”
          </p>
          <h6 className="Testimonial-person">
            <strong>~Jessica Grace Smith, writer + director
</strong>
          </h6>
        </div>
      </div>
    </div>
  )
}

export default Flip
